import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ExternalLinkIcon from 'assets/images/icons/external-link.svg?react';
import {
  DocumentLink,
  DocumentDeleteButton,
} from '../../LeadModalStayDetailsTab.styles';
import useDeleteIdentificationDocumentModal from '../useDeleteIdentificationDocumentModal';

const GovernmentFieldValue = ({
  passportID,
  passportCountryCode,
  hasIdentificationDocument,
  documentUrl,
  leadUid,
  extraGuestId,
}: {
  passportID?: string;
  passportCountryCode?: string;
  hasIdentificationDocument?: boolean;
  documentUrl?: string;
  leadUid?: string;
  extraGuestId?: number | null;
}) => {
  const { t } = useTranslation();
  const { openDeleteIdentificationDocumentModal } =
    useDeleteIdentificationDocumentModal();

  const hasDocument = Boolean(hasIdentificationDocument && documentUrl);

  return (
    <>
      {passportCountryCode ? `${passportCountryCode}, ` : ''}
      {passportID || ''}
      {hasDocument ? (
        <DocumentLink
          aria-label={t(
            'componentLead.modal.stayDetailsTab.guestInfo.downloadIdentificationDocument',
          )}
          href={documentUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          <ExternalLinkIcon />
        </DocumentLink>
      ) : (
        ''
      )}
      {hasDocument && leadUid ? (
        <DocumentDeleteButton
          aria-label={t(
            'componentLead.modal.stayDetailsTab.guestInfo.deleteIdentificationDocument',
          )}
          data-testid="delete-identification-document-button"
          onClick={() =>
            openDeleteIdentificationDocumentModal({ leadUid, extraGuestId })
          }
          type="button"
        >
          <Glyphicon glyph="trash" />
        </DocumentDeleteButton>
      ) : (
        ''
      )}
    </>
  );
};

GovernmentFieldValue.defaultProps = {
  passportID: '',
  passportCountryCode: '',
  hasIdentificationDocument: false,
  documentUrl: undefined,
  leadUid: undefined,
  extraGuestId: undefined,
};

export default GovernmentFieldValue;
